import { computed, ref } from 'vue'
import { getHome } from '@/common/requests/data-fetch/get-home'
import { getCategory } from '@/common/requests/data-fetch/get-category'
import { convertMultiSection } from '@/common/converter/convert-multi-section'
import { getCategorySub } from '@/common/requests/data-fetch/get-category-sub'

export const useHome = () => {
  const multiSectionList = ref([])
  const hasMultiSectionList = computed(
    () => multiSectionList.value && multiSectionList.value.length > 0,
  )

  /**
   * get home data
   * @returns {Promise<undefined|any>}
   */
  const getHomeData = async () => {
    const { data } = await getHome()
    if (!data) {
      return undefined
    }

    return data
  }

  /**
   * get category main code then return data after fetch
   * @param category
   * @returns {Promise<undefined|any>}
   */
  const getCategoryMainData = async ({ category = '' }) => {
    const { data } = await getCategory({ category })

    if (!data) {
      return undefined
    }

    return data
  }

  /**
   * get category main code and sub code then return data after fetch
   * @param category
   * @param subCategory
   * @returns {Promise<undefined|any>}
   */
  const getCategorySubData = async ({ category = '', subCategory = '' }) => {
    const { data } = await getCategorySub({ category, subCategory })
    if (!data) {
      return undefined
    }

    return data
  }

  /**
   * return legacy version of multi section list after convert
   * @param data
   * @returns {undefined|*}
   */
  const getMultiSectionList = (data) => {
    if (!data) return undefined

    const { multisectionlist } = convertMultiSection(data)
    multiSectionList.value = multisectionlist

    return multiSectionList.value
  }

  return {
    multiSectionList,
    hasMultiSectionList,
    getHomeData,
    getCategoryMainData,
    getCategorySubData,
    getMultiSectionList,
  }
}
